module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/text/font-a44731fa6682001155977cf029449cb4.svg";